import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { Router } from "@angular/router";
import { AuthenticationService } from "../services/auth.service";
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          //   this.authenticationService.logout(localStorage.getItem("token"));
          // location.reload();
          // this.router.navigate(["account/login"]);
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
